export default "__VITE_ASSET__Df$ETZwr__"